// extracted by mini-css-extract-plugin
export var buttons = "LinksList-module--buttons--a9402";
export var linksButton = "LinksList-module--linksButton--f2add";
export var linksList = "LinksList-module--linksList--108f4";
export var none = "LinksList-module--none--5cabc";